// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"418":"c634f39358bd29c15ce7","588":"a6faaecc7264b636e5b6"}[chunkId] + ".js?v=" + {"418":"c634f39358bd29c15ce7","588":"a6faaecc7264b636e5b6"}[chunkId] + "";
};